import axios from "axios";
import endpoints from "../../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    endpoint: endpoints.genreports_shop_balance_tx.endpoint, // "shop-balance-tx",
    endpoints: endpoints.genreports_shop_balance_tx.endpoints, // "shop-balance-txs",
    deleteEndpoint: endpoints.genreports_shop_balance_tx.deleteEndpoint, // "shop-balance-tx"
  },
  // -----------------------------------------------------------------
  getters: {
    endpoint: state => state.endpoint
  },
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, paginationData) => {
      const api =
        context.rootGetters["global/apiUrl"] + "/" + context.state.endpoints;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },

    create: (context, paginationData) => {
      const api =
        context.rootGetters["global/apiUrl"] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: "POST"
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },

    delete: (context, id) => {
      const api =
        context.rootGetters["global/apiUrl"] +
        "/" +
        context.state.deleteEndpoint +
        "/" +
        id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: "DELETE"
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === "string") {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    }
  }
};
